import React from 'react';
import HeaderActions from './Header/HeaderActions';
import HeaderInfo from './Header/HeaderInfo';
import DownloadButton from './Common/DownloadButton';
import useCandidateResultsHeader from './Hooks/UseCandidateResultsHeader';
import { useCandidatesResultsContext } from '../Contexts/CandidateResultsContext';
import CandidateResultTalentScoreGroup from './Header/CandidateResultTalentScoreGroup';
import AssessmentResetDialog from '../../components/dialogs/AssessmentResetDialog/AssessmentResetDialog';
import UIStrings from '@/Utils/UIStrings';
import ResultsTab from './ResultsTab';
import isFullReportDownloadDisabled from '@/Utils/isFullReportDownloadAllowed';

function ApplicantResultsHeader(): React.JSX.Element {
    const { results, resetAssessmentAsync } = useCandidatesResultsContext();

    const disableDownloadButton = isFullReportDownloadDisabled(results.talentScore);
    const { isReportDownloading, downloadReportHandler, openAssessmentResetDialog, setOpenAssessmentResetDialog } =
        useCandidateResultsHeader();

    return (
        <div className="border-border bg-background border-b">
            <div className="mx-auto w-full max-w-7xl">
                <div className="flex flex-col gap-5">
                    <div className="flex flex-row flex-wrap items-center gap-3 py-2.5">
                        <div className="min-w-0 flex-1">
                            <HeaderInfo />
                        </div>
                        <CandidateResultTalentScoreGroup
                            level={results.talentScore?.scoreLevel || 'Low'}
                            progress={results.talentScore?.talentScore}
                        />
                        <div className="shrink-0">
                            <DownloadButton
                                disabled={disableDownloadButton}
                                onClick={downloadReportHandler}
                                loading={isReportDownloading}
                                data-cy="downloadReportButton"
                                label={UIStrings.DownloadReport}
                            />
                        </div>
                        <HeaderActions setOpenAssessmentResetDialog={setOpenAssessmentResetDialog} />
                    </div>
                    <ResultsTab />
                </div>
            </div>
            <AssessmentResetDialog
                open={openAssessmentResetDialog}
                setOpen={setOpenAssessmentResetDialog}
                onConfirm={resetAssessmentAsync}
            />
        </div>
    );
}

export default ApplicantResultsHeader;
